<template>
  <button class="ui-btn" @click="handleClick" :disabled="disabled" :style="{ width: width }">
    <slot>
      {{ btnText }}
    </slot>
  </button>
</template>

<script>
export default {
  name: "uiButton",
  props: {
    btnText: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "100%"
    }
  },
  methods: {
    handleClick(e) {
      this.$emit("click", e)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-btn {
  width: 6.5rem;
  height: 0.88rem;
  background: #f64e45;
  border-radius: 0.44rem;
  color: #ffffff;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  outline: none;
  border: none;
  line-height: 0.88rem;
  text-align: center;
  &[disabled] {
    opacity: 0.5;
  }
  &:active {
    opacity: 0.7;
  }
}
</style>
